import {
  contractTypeLabel,
  EMPLOYEE_FUNCTION_LABELS,
} from "@etudescarre/constants";
import { cn } from "@etudescarre/ui";
import { isNotNil } from "@etudescarre/utils";
import { HardHatIcon } from "@phosphor-icons/react";
import { useYardContext } from "@/providers/yard-context";
import { YardCommissionToggle } from "./yard-commission-toggle";

const YARD_TYPE_LABELS: Record<string, string> = {
  lots_separes: "Lots séparés",
  entreprise_generale: "Entreprise générale",
  conception_realisation: "Conception-réalisation",
};

export function YardHome() {
  const { yard, contracts } = useYardContext();

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <div className="mb-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <HardHatIcon className="size-8 text-zinc-400" />
          <div>
            <h2 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100">
              {yard.name}
            </h2>
            <p className="text-sm text-zinc-500">
              {YARD_TYPE_LABELS[yard.type] ?? yard.type}
            </p>
          </div>
        </div>
        <YardCommissionToggle />
      </div>

      <div className="space-y-4">
        <h3 className="text-sm font-medium text-zinc-700 dark:text-zinc-300">
          Vos contrats sur ce chantier
        </h3>
        <div className="grid gap-3">
          {contracts.map((contract) => (
            <div
              key={contract.id}
              className="rounded-lg border border-zinc-200 bg-white p-4 dark:border-zinc-700 dark:bg-zinc-900"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium text-zinc-900 dark:text-zinc-100">
                    {contract.performerCompanyName}
                  </p>
                  <p className="text-sm text-zinc-500">
                    {contractTypeLabel(contract.type)}
                    {isNotNil(contract.code) && ` - ${contract.code}`}
                    {isNotNil(contract.function) &&
                      ` - ${EMPLOYEE_FUNCTION_LABELS[contract.function] ?? contract.function}`}
                  </p>
                </div>
                {contract.isReferent && (
                  <span className="rounded bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800 dark:bg-blue-900/30 dark:text-blue-400">
                    Référent
                  </span>
                )}
              </div>
              {contract.teams.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1">
                  {contract.teams.map((team) => (
                    <span
                      key={team.id}
                      className={cn(
                        "rounded px-2 py-0.5 text-xs",
                        team.isMember
                          ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400"
                          : "bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400",
                      )}
                    >
                      {team.name}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <p className="mt-8 text-center text-sm text-zinc-400">
        Utilisez le menu de navigation pour accéder aux différentes sections.
      </p>
    </div>
  );
}
